/*eslint-disable*/
import { useContext, useEffect, useState } from 'react';
import useFetchData from 'hooks/useFetchData';
import Button from '../../Button';
import PropTypes from 'prop-types';
import translating from './translating.json';
import './styles.scss';
import GlobalContext from 'contexts';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Api from 'utils/api';
import BasicModal from 'components/Customers/componenets/Modal/basic-modal';
import { calcBMI } from 'utils';
import enumMeaureSurvey from '../../../enums/enum-measure-survey';
import { RichTextEditor } from '../../RichTextEditor';
import { debounce } from 'lodash';

function SurveyTestForm({
  clientProductUuid,
  isSummery,
  handleChangeMode,
  positiveQuestions,
  doctorRecomends
}) {
  const [initDoctorSummery, setInitDoctorSummery] = useState(positiveQuestions);

  const { clientProductStageId, currentCustomer } = useContext(GlobalContext);

  const { data: surveyMeasures, loading } = useFetchData(
    `client-survey-measures/${clientProductUuid}`
  );
  const [measuresList, setMeasuresList] = useState([]);
  const [labsList, setLabsList] = useState([]);
  const [additionalList, setAdditionalList] = useState([]);
  const [measureTypesArr, setMeasuresTypeArr] = useState([]);
  const [summeriesList, setSummeriesList] = useState([]);
  const [measureTypes, setMeasuresType] = useState([
    { key: 'measures', active: true },
    { key: 'labs', active: false },
    { key: 'additional', active: false }
  ]);
  const [isCompleted, setIsCompleted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentInvalidMeasure, setCurrentInvalidMeasure] = useState();

  console.log({ summeriesList });

  useEffect(() => {
    setInitDoctorSummery(positiveQuestions);
  }, [positiveQuestions]);

  // const clientSurveyTestData = {
  //     date: 'eeeeeeee',
  //     type: 'בדיקת סקר'
  //     // name: `${currentCustomer.first_name} ${currentCustomer.last_name}`
  // };
  const clientSurveyTestFields = [
    { label: 'תאריך מפגש', name: 'date' },
    { label: 'שם הלקוח', name: 'name' },
    { label: 'סוג הפגישה', name: 'type' }
  ];

  useEffect(() => {
    if (surveyMeasures?.data?.length) {
      let tmpSurveyMeasures = [...surveyMeasures.data];
      tmpSurveyMeasures.forEach((sm) => {
        if (sm.value) {
          if (sm.isNumeric) {
            const value = Number(sm.value);

            if (
              (sm.minNormalValue && value < sm.minNormalValue) ||
              (sm.maxNormalValue && value > sm.maxNormalValue)
            ) {
              sm.invalid = true;
            }
          }
        }
        if (sm.options) sm.options = JSON.parse(sm.options);
      });
      setMeasuresList(
        tmpSurveyMeasures
          .filter((sm) => sm.type === 'measures')
          .sort((a, b) => a.orderNumber - b.orderNumber)
      );
      setLabsList(
        tmpSurveyMeasures
          .filter((sm) => sm.type === 'lab')
          .sort((a, b) => a.orderNumber - b.orderNumber)
      );
      setAdditionalList(
        tmpSurveyMeasures
          .filter((sm) => sm.type === 'additional')
          .sort((a, b) => a.orderNumber - b.orderNumber)
      );
      setSummeriesList(tmpSurveyMeasures.filter((sm) => sm.type === 'summery'));
      if (surveyMeasures.isCompleted) setIsCompleted(true);
    }
  }, [surveyMeasures]);

  useEffect(() => {
    if (additionalList.length)
      setMeasuresTypeArr([measuresList, labsList, additionalList]);
  }, [additionalList]);

  const saveClientMeasure = (id, value, measureClientProductId) => {
    Api.patch(`client-survey-measures/${id}`, {
      id: id,
      value: value,
      clientProductId: measureClientProductId
    }).then((res) => {
      if (res?.data?.isCompleted === true) setIsCompleted(true);
    });
  };

  const clearMeasureInput = (i, j) => {
    alert('ערך לא תקין');
    document.querySelectorAll('.table-measures')[i].children[
      j + 1
    ].children[2].children[0].value = null;
  };

  const onBlurHandler = (e, index, item, clientProductId) => {
    console.log('entered onBlurHandler');
    let value = isSummery ? e : e.target.value;
    if (!value) return;
    if (!isSummery) {
      let newList = [...measureTypesArr];
      const { currentI, currentJ } = findndices(newList, item);

      if (item.isNumeric) {
        value = Number(value);
        if (
          (item.minValue && value < item.minValue) ||
          (item.maxValue && value > item.maxValue)
        ) {
          newList[currentI][currentJ].value = null;
          clearMeasureInput(currentI, currentJ);
          return;
        } else if (
          (item.minRedFlagValue && value < Number(item.minRedFlagValue)) ||
          (item.maxRedFlagValue &&
            value > Number(item.maxRedFlagValue) &&
            !item.redFlag)
        ) {
          item.redFlag = true;

          const tmpItem = { ...item };
          setCurrentInvalidMeasure(tmpItem);
          setShowModal(true);
          newList[currentI][currentJ].value = null;
          clearMeasureInput(currentI, currentJ);
          return;
        } else if (
          (!item.redFlag &&
            !item.redFlag &&
            item.minNormalValue &&
            value < item.minNormalValue) ||
          (item.maxNormalValue && value > item.maxNormalValue)
        ) {
          newList[currentI][currentJ].value = value;
          newList[currentI][currentJ].invalid = true;
        }
      } else if (
        (!item.redFlag &&
          item.minRedFlagValue &&
          e.target.value === item.minRedFlagValue) ||
        (item.maxRedFlagValue && e.target.value === item.maxRedFlagValue)
      ) {
        const tmpItem = { ...item };
        setCurrentInvalidMeasure(tmpItem);
        setShowModal(true);
        newList[currentI][currentJ].redFlag = true;
        newList[currentI][currentJ].value = null;
        clearMeasureInput(currentI, currentJ);

        return;
      } else newList[currentI][currentJ].invalid = false;
      newList[currentI][currentJ].value = value;
      value = newList[currentI][currentJ].value;
      setMeasuresTypeArr(newList);
      if (
        item.surveyMeasureId === enumMeaureSurvey.weight ||
        item.surveyMeasureId === enumMeaureSurvey.height
      ) {
        const weight = measuresList.find(
          (m) => m.surveyMeasureId === enumMeaureSurvey.weight
        )?.value;
        const height = measuresList.find(
          (m) => m.surveyMeasureId === enumMeaureSurvey.height
        )?.value;
        if (weight && height) {
          let tmpMeasuresList = [...measuresList];
          const index = measuresList.findIndex(
            (m) => m.surveyMeasureId === enumMeaureSurvey.bmi
          );
          tmpMeasuresList[index].value = calcBMI(height, weight);
          setMeasuresList(tmpMeasuresList);
          let tmpMeasuresTypeArr = [...measureTypesArr];
          tmpMeasuresTypeArr[0] = tmpMeasuresList;
          setMeasuresTypeArr(tmpMeasuresTypeArr);
          saveClientMeasure(
            tmpMeasuresList[index].id,
            tmpMeasuresList[index].value,
            tmpMeasuresList[index].clientProductId
          );
        }
      }
      if (
        item.surveyMeasureId === enumMeaureSurvey.fev1Male ||
        item.surveyMeasureId === enumMeaureSurvey.fev1Female ||
        item.surveyMeasureId === enumMeaureSurvey.fvc
      ) {
        const fev1 = surveyMeasures.data.find(
          (m) =>
            m.surveyMeasureId ===
            (currentCustomer.gender === 'אשה'
              ? enumMeaureSurvey.fev1Female
              : enumMeaureSurvey.fev1Male)
        )?.value;

        const fvc = surveyMeasures.data.find(
          (m) => m.surveyMeasureId === enumMeaureSurvey.fvc
        )?.value;

        if (fev1 && fvc) {
          let tmpAdditionalList = [...additionalList];
          const index = tmpAdditionalList.findIndex(
            (m) => m.surveyMeasureId === enumMeaureSurvey['fev1/fvc']
          );
          tmpAdditionalList[index].value = fev1 / fvc;
          setAdditionalList(tmpAdditionalList);
          let tmpMeasuresTypeArr = [...measureTypesArr];
          tmpMeasuresTypeArr[2] = tmpAdditionalList;
          setMeasuresTypeArr(tmpMeasuresTypeArr);
          saveClientMeasure(
            tmpAdditionalList[index].id,
            tmpAdditionalList[index].value,
            tmpAdditionalList[index].clientProductId
          );
        }
      }
      if (
        item.surveyMeasureId === enumMeaureSurvey.rightEye ||
        item.surveyMeasureId === enumMeaureSurvey.leftEye
      ) {
        const rightEye = surveyMeasures.data.find(
          (m) => m.surveyMeasureId === enumMeaureSurvey.rightEye
        )?.value;
        const leftEye = surveyMeasures.data.find(
          (m) => m.surveyMeasureId === enumMeaureSurvey.leftEye
        )?.value;
        if (
          rightEye &&
          leftEye &&
          Math.abs(rightEye - leftEye) >= 5 &&
          !item.redFlag
        ) {
          let newList = [...measureTypesArr];
          const tmpItem = { ...item };
          setCurrentInvalidMeasure(tmpItem);
          setShowModal(true);
          newList[currentI][currentJ].redFlag = true;
          newList[currentI][currentJ].value = null;
          clearMeasureInput(currentI, currentJ);

          return;
        }
      }
      saveClientMeasure(item.id, value, item.clientProductId);
    } else saveClientMeasure(item.id, value, item.clientProductId);
  };

  const findndices = (arr, item) => {
    let currentI, currentJ;
    arr.forEach((arr, i) => {
      if (arr[0].type === item.type) {
        currentI = i;
        return;
      }
    });
    currentJ = arr[currentI].findIndex(
      (a) => a.surveyMeasureId === item.surveyMeasureId
    );
    return { currentI, currentJ };
  };

  const onChangeHandler = (e, index, item) => {
    let value = e.target.value;
    let newList = [...measureTypesArr];
    const { currentI, currentJ } = findndices(newList, item);
    newList[currentI][currentJ].value = value;
    setMeasuresTypeArr(newList);
  };

  const onSummeryChangeHandler = (value, index, clientProductId) => {
    console.log('value: ', value);
    const saveDoctorSummeryDebounced = debounce(
      () => onBlurHandler(value, index, clientProductId),
      1000
    );
    saveDoctorSummeryDebounced();
    let newList = [...summeriesList];
    newList[index].value = value;
    setSummeriesList(newList);
  };

  const handleActivemeasureType = (index) => {
    const tmpTypeArr = [...measureTypes];
    if (measureTypes[index].active === true) tmpTypeArr[index].active = false;
    else {
      tmpTypeArr.forEach((item) => {
        item.active = false;
      });
      tmpTypeArr[index].active = true;
    }
    setMeasuresType(tmpTypeArr);
  };

  const handleSubmitRedFlag = () => {
    let newList = [...measureTypesArr];
    const { currentI, currentJ } = findndices(newList, currentInvalidMeasure);
    newList[currentI][currentJ].outOfRange = true;
    setShowModal(false);
  };

  const handleUpdateProductStage = () => {
    Api.post(
      `client-product-stage/surveyCompleteProductStage/${clientProductStageId}`
    ).then((res) => {
      if (res?.data?.affected === 1) handleChangeMode(null);
    });
  };

  const onRedFlagBlurHandler = (e) => {
    Api.post(`client-survey-measures/redFlag/${currentInvalidMeasure.id}`, {
      redFlagValue: currentInvalidMeasure.value,
      redFlagText: e.target.value,
      id: currentInvalidMeasure.id,
      clientProductId: currentInvalidMeasure.clientProductId,
      value: null
    }).then((res) => {
      if (res?.data?.affectedRows === 1) {
        let newList = [...measureTypesArr];
        const { currentI, currentJ } = findndices(
          newList,
          currentInvalidMeasure
        );
        newList[currentI][currentJ].redFlagValue = currentInvalidMeasure.value;
        newList[currentI][currentJ].redFlagText = e.target.value;
        setMeasuresTypeArr(newList);
      }
    });
  };

  return (
    <div className="updatingBloodTests surveyTestForm">
      {!isSummery && (
        <div>
          {/* <div>
                        <PersonalDetailsContent
                            data={clientSurveyTestData}
                            fields={clientSurveyTestFields}
                        ></PersonalDetailsContent>
                    </div> */}
          <div className="list">
            {loading || !surveyMeasures?.data?.length ? (
              <>Loading..</>
            ) : (
              <div>
                {measureTypesArr.map((measureType, count) => (
                  <div key={count} className="wrapper-group-test">
                    <div
                      className="measure-group-title"
                      onClick={() => handleActivemeasureType(count)}
                    >
                      {' '}
                      {translating[measureTypes[count].key]}
                      <ArrowDropDownIcon></ArrowDropDownIcon>
                    </div>
                    <div>
                      {measureTypes[count].active && (
                        <table className="table-measures">
                          <thead>
                            <tr>
                              <th>קטגוריה</th>
                              <th>רשימת מדדים</th>
                              <th>נתונים להזנה</th>
                              <th>נדרש?</th>
                              <th>ערך נמוך</th>
                              <th>ערך גבוה</th>
                              <th>ערך מדד חריג</th>
                              <th>הערת מדד חריג</th>
                            </tr>
                          </thead>

                          {measureTypes[count].active &&
                            measureType.map((item, index) => (
                              <tbody>
                                <td>
                                  <label>{item.category}</label>
                                </td>
                                <td>
                                  <label>{item.name}</label>
                                </td>
                                <td>
                                  {!item.isNumeric && item.options ? (
                                    <select
                                      value={item.value}
                                      onChange={(e) =>
                                        onChangeHandler(e, index, item)
                                      }
                                      onBlur={(e) =>
                                        onBlurHandler(e, index, item)
                                      }
                                    >
                                      {item.options?.map((option) => (
                                        <option value={option.text}>
                                          {option.text}
                                        </option>
                                      ))}
                                    </select>
                                  ) : (
                                    <input
                                      className={`${
                                        item.invalid ? 'invalid' : ''
                                      }`}
                                      onChange={(e) =>
                                        onChangeHandler(e, index, item)
                                      }
                                      onBlur={(e) =>
                                        onBlurHandler(e, index, item)
                                      }
                                      value={item?.value}
                                      min={item.minNormalValue}
                                      max={item.maxNormalValue}
                                      type={item.isNumeric ? 'number' : ''}
                                    />
                                  )}
                                </td>
                                <td>
                                  <label>
                                    {item.isRequired
                                      ? item.isRequired === 1
                                        ? 'כן'
                                        : 'לא'
                                      : 'לא'}
                                  </label>
                                </td>
                                <td>
                                  <label>{item.minNormalValue}</label>
                                </td>
                                <td>
                                  <label>{item.maxNormalValue}</label>
                                </td>
                                <td>
                                  <label className="red-flag">
                                    {item.redFlagValue}
                                  </label>
                                </td>
                                <td>
                                  {' '}
                                  <label className="red-flag">
                                    {item.redFlagText}
                                  </label>
                                </td>
                              </tbody>
                            ))}
                        </table>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="BtnSection">
            <Button
              handleClick={handleUpdateProductStage}
              txt="הושלם"
              className="saveBtn"
              disable={!isCompleted}
            />
          </div>
        </div>
      )}
      {isSummery && (
        <div className="summery-section">
          {summeriesList.map((item, index) => (
            <div key={index} className="labInpGroup">
              <label>{item.name}</label>
              <RichTextEditor
                value={
                  item.name === 'סיכום רופא'
                    ? initDoctorSummery
                    : item.name === 'המלצות'
                    ? doctorRecomends
                    : null
                }
                className={`${item.invalid ? 'invalid' : ''}`}
                onBlur={(e, a, b) => {
                  // onBlurHandler(b?.getHTML(), index, item);
                }}
                onChange={(value) => {
                  onSummeryChangeHandler(value, index, item);
                }}
              />
            </div>
          ))}
          <Button
            handleClick={handleUpdateProductStage}
            txt="שמור"
            className="saveBtn"
          />
        </div>
      )}
      {showModal && (
        <BasicModal width={500} height={`80%`}>
          <div>
            <div>מטפל - שים לב כי נרשם מדד חריג</div>
            <div>{currentInvalidMeasure.redFlagInfo}</div>
            <textarea
              className="red-flag-textarea"
              onBlur={(e) => onRedFlagBlurHandler(e)}
              // onChange={(e) => onSummeryChangeHandler(e, index, item)}
              // value={item?.value}
            />
            <Button
              className="red-flag-button"
              handleClick={() => handleSubmitRedFlag()}
            ></Button>

            {/* <input
                            className={`${currentInvalidMeasure.invalid ? 'invalid' : ''}`}
                            onChange={(e) => onChangeHandler(e, null, currentInvalidMeasure)}
                            onBlur={(e) => onBlurHandler(e, null, currentInvalidMeasure)}
                            value={currentInvalidMeasure?.value}
                            min={currentInvalidMeasure.minValue}
                            max={currentInvalidMeasure.maxValue}
                            type={currentInvalidMeasure.isNumeric ? 'number' : ''}
                        /> */}
          </div>
        </BasicModal>
      )}
    </div>
  );
}

export default SurveyTestForm;

SurveyTestForm.propTypes = {
  clientProductUuid: PropTypes.string,
  handleChangeMode: PropTypes.func,
  isSummery: PropTypes.bool
};
